import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link, Redirect } from "react-router-dom"
import apiResponse from '../../../../../services/apiResponse'
import DataTableBloc from '../Index/Blocs/DataTableBloc'

class CreateView extends Component {
    dataTableBloc = new DataTableBloc();

    constructor(props) {
        super(props);
        this.state = {
            dataForm: {},
            confirm: false,
            loading: false,
            success: false,
            failed: false,
            redirect: false
        };
    }

    submitData = async () => {
        await this.dataTableBloc.fetchCreate(this.state.dataForm);
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault();
        this.setState({
            dataForm: { ...values },
            confirm: true
        });
    }

    confirmResponse = (response) => {
        let forState = {};
        switch (response) {
            case 'cancel':
                forState = { confirm: false };
                break;
            case 'confirm':
                forState = { loading: true, confirm: false };
                this.submitData();
                break;
            case 'success':
                forState = { success: false, redirect: true };
                break;
            case 'failed':
                forState = { failed: false };
                break;
            default:
        }
        this.setState(forState);
    }

    componentDidMount() {
        this.dataTableBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        this.setState({ loading: false, success: true });
                    } else {
                        this.setState({ loading: false, failed: true });
                    }
                    break;
                case apiResponse.ERROR:
                    this.setState({ loading: false, failed: true });
                    break;
                default:
                    break;
            }
        });
    }

    componentWillUnmount() {
        this.dataTableBloc.createChannel.unsubscribe();
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Tambah Master Bagian Soal</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label htmlFor="ms360_question_type_name" className="col-md-2 col-form-label">
                                                Nama Bagian Soal <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="ms360_question_type_name"
                                                    id="ms360_question_type_name"
                                                    placeholder="Contoh: BerAKHLAK / MANSOSKUL"
                                                    validate={{ required: { value: true, errorMessage: 'Nama Bagian Soal wajib diisi' } }}
                                                    type="text"
                                                    className="form-control"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label htmlFor="ms360_question_type_description" className="col-md-2 col-form-label">
                                                Keterangan
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="ms360_question_type_description"
                                                    id="ms360_question_type_description"
                                                    placeholder="Keterangan / Deskripsi Bagian Soal"
                                                    type="textarea"
                                                    rows="3"
                                                    className="form-control"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="2"></Col>
                                            <Col md="10">
                                                <Link to={window.location.pathname}>
                                                    <Button color="secondary">
                                                        <i className="uil-arrow-left me-1"></i> Kembali
                                                    </Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-save me-1"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data Bagian Soal berhasil disimpan"
                    failedTitle="Gagal!"
                    failedInfo="Data Bagian Soal gagal disimpan"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />
                {this.state.redirect ?
                    <Redirect to={window.location.pathname} />
                    : null}
            </Fragment>
        );
    }
}

export default CreateView
